import { Directive, Output, EventEmitter, HostListener, HostBinding } from '@angular/core';

@Directive({
  selector: '[appDragDrop]',
  standalone: false
})
export class DragDropDirective {
  @Output() filesDropped = new EventEmitter<FileList>();
  @Output() draggedOver = new EventEmitter<boolean>();

  @HostBinding('class.over') isOver = false;

  @HostListener('dragover', ['$event'])
  onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isOver = true;
    this.draggedOver.emit(true);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isOver = false;
    this.draggedOver.emit(false);
  }

  @HostListener('drop', ['$event'])
  onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.isOver = false;
    this.draggedOver.emit(false);
    if (evt.dataTransfer?.files?.length) {
      this.filesDropped.emit(evt.dataTransfer.files);
    }
  }
}